import { actions } from '../../actions/common/countries';

export default function countries ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {

        case actions.SET_COUNTRIES:
            return setCountries( newState, action.countries );

            default:
                return newState;
    }
}

function setCountries ( newState, countries ) {
    newState.countries = countries;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/common/countries.js